// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__nE7Le","edit-button":"styles_edit-button__3ecmf","editButton":"styles_edit-button__3ecmf"};